
// import VXETable from "vxe-table";

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AxiosData } from "@/common/http/http";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";
import { DeepLoop } from "@/common/deepLoop/deepLoop";
import { IdolSupplementCreateGoodsOrderAPI } from "@/common/api/userManage/idolSupplementCreateGoodsOrder";

import { closeCurrentBreadTag } from '@/components/Tags.vue'

import { CommonApi } from "@/common/api/common";

import gallery from "@/components/gallery.vue";

// import ZlSelect from "@/components/third-custom-components/select";

// import ZlOption from "@/components/third-custom-components/option";

import { excuteDownloadExport2Excel } from "@/common/xlsx";
export const pageApiList = getPageAPIs(IdolSupplementCreateGoodsOrderAPI);

import {
  shareConfirmOptions,
  // transferUserLevel2ch,
  // leagueLevelName2Text,
} from "@/common/config";

const defaultSaleMachineFilterForm = {
  searchGoodsName: '' // 搜索商品名称
}

const defaultManualGoodsForm = {
  name: '',
  c_price: ''
}

const defaultManualGoosType = '自定义'

// VXETable.renderer.add("PandaInputNumber", {
//   // 可编辑激活模板
//   renderEdit(h, renderOpts, { row, column }) {
//     const self = this
//     return [
//       // <input class="my-cell" text="text" v-model={ row[column.property] } />
//       h('div', {
//         class: ['flex-row-center--center', 'panda-table-edit-input-number'],
//         domProps: {
//           style: `height: 80px;`
//         }
//       }, [
//         h("el-input-number", {
//         // text: "text",
//         attrs: {
//           min: 1,
//           max: 999,
//           size: 'small'
//         },
//         props: {
//           value: row[column.property]
//         },
//         domProps: {
//           // value: row[column.property]
//         },
//         on: {
//           change: function (value: number) {
//             console.log(value, 'value')
//             console.log(self, 'self')
//             // console.log(this, 'this')
//             self.$emit('edit-num-change', {
//               row,
//               column,
//               editVal: value
//             })
//           }
//         },
//       })
//       ]),
//     ];
//   },
//   // 可编辑显示模板
//   renderCell(h, renderOpts, { row, column }) {
//     return [
//       h("span", row[column.property])
//     ];
//   },
// });

@Component({
  filters: {
    showCreateOrderPayPrice(orderGoordsItem: any) {
      const {
        num = 0,
        c_price = 0
      } = orderGoordsItem || {}

      return parseFloat((num * c_price).toFixed(2))
    }
  },
  components: {
    // ZlSelect,
    // ZlOption,
    gallery,
  },
})
export default class IdolSupplementCreateGoodsOrder extends Vue {
  private supplementCreateGoodsOrderApi: any;

  private deepLoopUtil: any;

  // private MIN_SCORE_NUM: number = MIN_SCORE_NUM

  // private MAX_SCORE_NUM: number = MAX_SCORE_NUM

  private utilIns: any;

  // private debounceRefreshSingleCardInfoFunc: any

  private commonApi: any;
  constructor() {
    super();
    this.supplementCreateGoodsOrderApi = new IdolSupplementCreateGoodsOrderAPI();

    this.deepLoopUtil = new DeepLoop();

    this.commonApi = new CommonApi();

    this.saleMachineFilterForm = {
      ...this.deepLoopUtil.deepCopy(defaultSaleMachineFilterForm)
    }

    this.manualGoodsForm = {
      ...this.deepLoopUtil.deepCopy(defaultManualGoodsForm)
    }
    // this.form = {
    //   ...this.deepLoopUtil.deepCopy(defaultForm),
    // };

    // this.forms = {
    //   ...this.deepLoopUtil.deepCopy(defaultForms, false),
    // }

    this.utilIns = new Util();

    // this.debounceRefreshSingleCardInfoFunc = this.utilIns.debounce.call(
    //   this,
    //   this.refreshSingleCardAccountInfo,
    //   800
    // )
  }

  // 预览媒体文件
  private previewImages: any[] = [];

  // private handleClickChangePoint(btnItem: any, mode: string) {
  //   const form = this.form
  //   // changeMode: add | sub | clear
  //   function changePointKeys(target: any, mode: string, changeMode: string, keys: string[], point: number = 0) {
  //     keys.forEach((key) => {
  //       const cur_point = target[mode][key]

  //       if (!isNaN(cur_point)) {
  //         target[mode][key] = Number(cur_point)

  //         switch (changeMode) {
  //           case 'add':
  //             target[mode][key] += point
  //             break;
  //           case 'sub':
  //             target[mode][key] -= point
  //             break;
  //           case 'clear':
  //             target[mode][key] = 0
  //             break;
  //         }
  //       }
  //     })
  //   }

  //   switch (mode) {
  //     case 'left':
  //       changePointKeys(form, mode, 'add', ['single_max_score', 'score'], btnItem.value)

  //       changePointKeys(form, 'right', 'clear', ['single_max_score'])
  //       break;
  //     case 'right':
  //       changePointKeys(form, mode, 'add', ['single_max_score', 'score'], btnItem.value)

  //       changePointKeys(form, 'left', 'clear', ['single_max_score'])
  //       break;
  //   }

  //   this.form = form
  // }

  private form: any;

  private forms: any;

  private firstLoading: boolean = true;
  // private chooseTechnicianItem : any = null;

  // private tablePage: any = {
  //   totalCount: 0,
  //   pageNo: 1,
  //   pageSize: 10,
  //   pageSizes: [10, 20, 50, 100, 200, 500],
  // };

  private get getGoodsOrderId() {
    const { query = {} } = this.$route || {};

    const { goods_order_id = "" } = query;

    return goods_order_id;
  }

  private get getSaleMachineDeviceId() {
    const { query = {} } = this.$route || {};

    const { device_id = "" } = query;

    return device_id;
  }

  private activated(): void {
    this.getTable();

    this.initPageInfo()
  }

  private initPageInfo() {
    this.initMaualGoodsInfo()

    this.initCreateOrderList()
  }

  /** 手动添加商品 数据 */ 

  // 货柜商品字段
  private manualGoodsList: any[] = [];
  private manualGoodsForm: any = {}
  private manualGoodsVisible: boolean = false
  private formLabelWidth: string = '90px'
  private saleMachineInsideGoodsList: any[] = [];

  private saleMachineFilterForm: any = {

  }

  private showGoodsList: any[] = []
  

  // end 货柜商品字段

  private manualIdx: number = 0

  private initMaualGoodsInfo() {
    this.manualIdx = 0
    this.manualGoodsList = []
  }

  private onSaleGoodsSearch() {
    this.refreshShowGoodsList()
  }

  private onAddManualGoodItem() {
    const manualGoodsForm = this.manualGoodsForm

    const manualIdx = this.manualIdx

    const {
      name,
      c_price
    } = manualGoodsForm || {}

    console.log(manualGoodsForm, 'manualGoodsForm')

    if (!name) {
      this.$message.error('请输入商品名称')
      return
    }

    if (!c_price) {
      this.$message.error('请输入商品价格')
      return 
    }

    const manualGoodItem = {
      id: Date.now() + manualIdx,
      type: defaultManualGoosType,
      _isManual: true,
      name,
      c_price
    }

    ++this.manualIdx

    this.manualGoodsList.push(manualGoodItem)

    this.manualGoodsForm = {
      ...this.deepLoopUtil.deepCopy(defaultManualGoodsForm)
    }

    this.manualGoodsVisible = false

    this.refreshShowGoodsList()
  }

  private refreshShowGoodsList() {
    const saleMachineFilterForm = this.saleMachineFilterForm
    const {
      searchGoodsName
    } = saleMachineFilterForm

    const manualGoodsList = this.manualGoodsList

    const saleMachineInsideGoodsList = this.saleMachineInsideGoodsList

    if (searchGoodsName) {
      const searchGoodsList = saleMachineInsideGoodsList.filter((goodItem: any) => goodItem.name ? goodItem.name.includes(searchGoodsName) : false).concat(manualGoodsList.filter((goodItem: any) => goodItem.name ? goodItem.name.includes(searchGoodsName) : false))

      const restGoodsList = saleMachineInsideGoodsList.filter((goodItem: any) => goodItem.name ? !goodItem.name.includes(searchGoodsName) : false).concat(manualGoodsList.filter((goodItem: any) => goodItem.name ? !goodItem.name.includes(searchGoodsName) : false))

      this.showGoodsList = [
        ...searchGoodsList,
        ...restGoodsList
      ]
    } else {
      this.showGoodsList = [
        ...saleMachineInsideGoodsList,
        ...manualGoodsList
      ]
    }
  }

  private getTable(): void {
    this.supplementCreateGoodsOrderApi.getSaleMachnieGoodsList(
      {
        device_id: this.getSaleMachineDeviceId,
      },
      (res: any) => {
        console.log(res, "res");
        // this.tableData = res.data;
        const { list } = res.data;

        const saleMachineInsideGoodsList = list
          .map((item: any) => {
            const {
              // name,
              goods = [],
            } = item || {};

            goods.forEach((goodItem: any) => goodItem.num = 0)

            return goods;
          })
          .flat(1);

        this.saleMachineInsideGoodsList = saleMachineInsideGoodsList;

        this.refreshShowGoodsList()

        this.firstLoading = false;
      },
      () => {
        this.firstLoading = false;
      },
      false
    );
  }

  // 后台返回的字段 转化为前端定义的字段
  private handleTableData(data: any): any {
    // const { gender } = data;
    const newData = {
      ...data,
      // device_name: orderDeviceType2ch[device],
      // pay_type_name: payType2ch[pay_type],
      // user_level_type_name: userLevel2ch[user_type],
      // gender_sex: transfromGenders[gender]
    };

    return newData;
  }

  private onChangeAllChooseOrderGoods({ checked, records  }: any) {
    console.log(records, checked, 'records, checked')
    this.refreshCreateOrderGoodsList(records)
  }

  private onChangeChooseOrderGoods({ checked, records  }: any) {
    console.log(records, checked, 'records, checked')
    this.refreshCreateOrderGoodsList(records)
  }

  private initCreateOrderList() {
    this.createOrderGoodsList = []

    this.creatOrderInfo = {
      num: 0,
      price: 0
    }
  }


  // 订单标注字段
  private createOrderGoodsList: any[] = []

  private creatOrderInfo: any = {
    num: 0,
    price: 0,
  }
  
  // end 订单标注字段

  // private onEditOrderGoodsNum({ row, column, editVal }: any) {
  //   const createOrderGoodsList = this.createOrderGoodsList

  //   console.log(row, column, editVal, 'row, column, editVal')

  //   const existOrderGoodsIdx = createOrderGoodsList.findIndex((orderGoodsItem: any) => orderGoodsItem.id === row.id)

  //   if (existOrderGoodsIdx > -1) {
  //     createOrderGoodsList[existOrderGoodsIdx][column.property] = editVal

  //     this.createOrderGoodsList = createOrderGoodsList
  //   }
  // }

  private refreshCreateOrderGoodsList(checkRecord: any[] = []) {
    const prevOrderGoods = this.createOrderGoodsList

    /** 不适用 records 直接覆盖的原因： 保留已有商品的 数量字段 */
    const restPrevGoods = prevOrderGoods.filter((orderGoodItem: any) => checkRecord.some((checkItem: any) => checkItem.id == orderGoodItem.id))

    const addGoods = checkRecord.filter((checkItem: any) => !restPrevGoods.some((restPrevGItem: any) => checkItem.id == restPrevGItem.id)).map((item) => {
      const newItem = {
        ...item,
        num: 1
      }

      return newItem
    })

    const orderGoods = [...restPrevGoods, ...addGoods]

    console.log(orderGoods, 'orderGoods')

    this.createOrderGoodsList = orderGoods
  }

  @Watch('createOrderGoodsList', { deep: true })
  $refreshOrderTotalInfo(newList: any) {
    let num = 0, price = 0

    newList.forEach((goodsItem: any) => {
      const {
        num: eachNum,
        c_price
      } = goodsItem || {}

      num += eachNum

      price += (c_price * eachNum)
    })

    price = parseFloat(price.toFixed(2))

    const creatOrderInfo = {
      num,
      price,
    }

    this.creatOrderInfo = creatOrderInfo
  }

  private supplementOrderLoading: boolean = false
  private onCreateNewOrder() {
    const creatOrderInfo = this.creatOrderInfo

    const {
      num
    } = creatOrderInfo || {}

    if (num > 0) {
      this.$confirm(`确认后将立即执行扣款，并且不可再次标记！`, "提示", {
        ...shareConfirmOptions,
      }).then(() => {
        this.supplementOrderLoading = true
        // setTimeout(() => {
        //   this.getSupplementAbnormalOrderParams()
        //   this.$message.success('生单成功')
        //   this.supplementOrderLoading = false

        //   closeCurrentBreadTag()

        //   this.$router.go(-1)
        // }, 1000)

        this.supplementCreateGoodsOrderApi.supplementSaleMachineGOrder(
          {
            ...this.getSupplementAbnormalOrderParams()
          },
          () => {
            this.$message.success('生单成功')
            this.supplementOrderLoading = false

            closeCurrentBreadTag()

            this.$router.go(-1)
          },
          () => {
            this.supplementOrderLoading = false
          }
        )
      })
    } else {
      this.$message.error('请至少选中一个商品')
    }
  }

  private getSupplementAbnormalOrderParams() {
    const createOrderGoodsList = this.createOrderGoodsList

    const params = {
      id: this.getGoodsOrderId
    }

    const goods = createOrderGoodsList.map((goodsItem: any) => {
      const {
        id,
        _isManual,
        name,
        num,
        c_price
      } = goodsItem || {}

      const goodsParams = {
        type: 1, // 商品类型 1内置商品 2手动添加商品
        num
      }

      if (_isManual) {
        Object.assign(goodsParams, {
          type: 2,
          price: c_price,
          name
        })
      } else {
        Object.assign(goodsParams, {
          id
        })
      }

      return goodsParams
    })

    Object.assign(params, {
      goods
    })

    return params
  }


  private restForm(): void {
    // this.form = {
    //   ...this.deepLoopUtil.deepCopy(defaultForm),
    // };

    this.getTable();
  }

  private search(): void {
    // this.tablePage.pageNo = 1;
    // this.tableData = [];
    // this.tablePage.totalCount = 0;

    this.getTable();
  }

  private tableData: any[] = [];

  private handlePageChange(val: any) {
    // this.tablePage.pageNo = val.currentPage;
    // this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }

  private exportTable() {
    // new HealthWarning().exportTable(this.form);
  }
}
